export default {"src":"/_next/static/image/public/images/flags/flag_385.94c805f8d1ab2f46c9c7294c727bdb40.svg","height":16,"width":24};